import { render, staticRenderFns } from "./AppBrand.vue?vue&type=template&id=058ee3b0&"
import script from "./AppBrand.vue?vue&type=script&lang=js&"
export * from "./AppBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports